import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryPageAgentPromotionsSectionComponent } from './summary-page-agent-promotions-section.component';

@NgModule({
    imports: [CommonModule, RouterModule, TgGridModule, TgRackModule],
    declarations: [SummaryPageAgentPromotionsSectionComponent],
    exports: [SummaryPageAgentPromotionsSectionComponent]
})
export class SummaryPageAgentPromotionsSectionModule {}
